<div class="body-content">
  <router-outlet></router-outlet>
  <app-footer> </app-footer>
</div>
